(function () {
  /**
   * Gets a url from a fallback name.
   *
   * @param {string} fallbackName The name of the fallback image to use.
   * @returns An image url.
   */
  function getFallback(fallbackName) {
    switch (fallbackName) {
      case 'vehicle':
      default:
        return '/content/themes/ford-oem-theme/dist/img/no-photo.webp';
    }
  }

  /**
   * Checks that an image element actually has a value for src.
   *
   * @param {HTMLImageElement} image
   * @returns {bool} True if src is a real value.
   */
  function hasSrc(image) {
    const baseUri = document.baseURI;
    return image.src && image.src !== baseUri;
  }

  /**
   * Changes the image url and adds a class.
   *
   * @param {HTMLImageElement} image
   */
  function applyFallback(image) {
    // Get the correct fallback for the image.
    const fallbackUrl = getFallback(image.getAttribute('data-fallback-image'));
    image.classList.add('js-fallback-image-replaced');

    if (image.src !== fallbackUrl) {
      image.src = fallbackUrl;
    }
  }

  /**
   * Sets up the fallback logic for an image tag.
   *
   * This takes the extra steps to work regardless of whether or not the image
   * has already failed by the time the fallbacks are set up.
   *
   * Image elements that have a `data-fallback-image` attribute set in the
   * markup will automatically have this logic applied.
   *
   * Images that are added or modified via JS will need to have this explicitly
   * called.
   *
   * @param {HTMLImageElement} image The image to add event listeners to.
   */
  const setupFallbackImages = (image) => {
    // Handle images that already failed before this function.
    if (hasSrc(image) && image.complete && image.naturalWidth === 0) {
      applyFallback(image);
      return;
    }

    // Create a self-removing event listener.
    const listener = function (e) {
      e.target.removeEventListener('error', listener);
      applyFallback(image);
    };

    // Attach it.
    image.addEventListener('error', listener);
  };

  // Auto-setup fallbacks for any existing images with a fallback attribute.
  document.querySelectorAll('img[data-fallback-image]').forEach(setupFallbackImages);

  // Make the setup function available to other scripts.
  window.setupFallbackImages = setupFallbackImages;
})();
